import styled from 'styled-components';

import { Button } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

import { WidgetButtonProps } from './WidgetButton.types';

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${Colors.BrandBlueLightest};
  color: ${Colors.BrandBlue};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
  border: 1px solid ${ct({ Dark: Colors.VioletMiddleLighter, Light: Colors.VioletMiddleLighter })};
`;

export const WidgetButtonStyled = styled(Button)<WidgetButtonProps>`
  &:hover {
    ${IconContainer} {
      background: ${ct({ Dark: Colors.BrandBlueMiddle, Light: Colors.BrandBlueMiddle })};
      border-color: ${ct({ Dark: Colors.BrandBlueMiddle, Light: Colors.BrandBlueMiddle })};
      color: ${ct({ Dark: Colors.White, Light: Colors.White })};
    }
  }

  &:disabled {
    ${IconContainer} {
      background: ${ct({ Dark: Colors.GreyDarkerMiddle, Light: Colors.GreyDarkerMiddle })};
      border-color: ${ct({ Dark: Colors.GreyDarkerMiddle, Light: Colors.GreyDarkerMiddle })};
      color: ${ct({ Dark: Colors.White, Light: Colors.White })};
    }
  }
`;
